import LottieAnimation from '@/animations/LottieAnimation.tsx';
import loadingAnimationData from '@/components/common/svg/assets/loader_rounded.json';
import CheckShape from '@/components/common/svg/shapes/CheckShape.tsx';
import { ViewMessageType } from '@/enums/viewEnums.ts';
import { MessageTypes } from '@/enums/apiEnums.ts';
import { MessageUI } from '@/api/messaging/types.ts';
import ErrorShape from '@/components/common/svg/shapes/ErrorShape.tsx';

export const MessageStatus = ({
  messageType,
  message,
  onResend
}: {
  message: MessageUI;
  messageType: ViewMessageType;
  onResend?: (messageId: string) => void;
}) => {
  const showFormattedTime =
    [ViewMessageType.INBOX, ViewMessageType.OUTBOX].includes(messageType) &&
    ![MessageTypes.TYPE_STICKER, MessageTypes.TYPE_ICEBREAKER_GIFT].includes(
      message.type
    );

  const messageTimestamp = new Date(Number(message.create_micros) / 1000);
  const formattedTime = messageTimestamp.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit'
  });

  if (message.status?.isError) {
    const handleRetry = () => {
      if (onResend && message.status?.id) {
        onResend(message.status.id);
      }
    };

    return (
      <div
        style={{
          alignSelf: 'flex-end',
          fontSize: '10px'
        }}
        onClick={handleRetry}
      >
        <ErrorShape />
      </div>
    );
  }

  const statusIndicator = () => {
    return message.status?.isSending ? (
      <div
        style={{
          alignSelf: 'flex-end',
          fontSize: '10px'
        }}
      >
        <LottieAnimation
          animationData={loadingAnimationData}
          loop={true}
          width={10}
          height={10}
          styles={{ color: '#000000' }}
        />
      </div>
    ) : (
      <div
        style={{
          alignSelf: 'flex-end'
        }}
      >
        <CheckShape
          width={12}
          height={12}
          style={{ position: 'absolute', bottom: 1 }}
        />
      </div>
    );
  };

  return showFormattedTime ? (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        opacity: 0.4,
        alignSelf: 'flex-end',
        fontSize: '10px',
        textAlign: 'center',
        marginRight:
          messageType === ViewMessageType.OUTBOX && !message.status?.isSending
            ? '10px'
            : 0
      }}
    >
      {formattedTime}
      {messageType === ViewMessageType.OUTBOX && statusIndicator()}
    </div>
  ) : null;
};